import inserted from '@mailobj-browser/front/js/tree/inserted.js'
import { removed } from '@mailobj-browser/front/js/tree/tree.js'
import { elements } from '../../../styles.js'
import * as sharedClasses from '#utilities/js/ea/sharedClasses.js'

export default form => {
  const { ownerDocument } = form
  const { body } = ownerDocument

  queueMicrotask(async () => {
    // @todo FB A supprimer quand web2 et default seront fusionnés
    await inserted(form, body)
    sharedClasses.add(form, elements.message)
  })

  queueMicrotask(async () => {
    // @todo FB A supprimer quand web2 et default seront fusionnés
    await removed(form)
    sharedClasses.remove(form, elements.message)
  })
}
